import React from "react";
import PropTypes from "prop-types";
import SortDirection from "react-virtualized/dist/commonjs/Table/SortDirection";
import styled from "styled-components";

const StyledSvg = styled.svg`
  fill: #656565;
  visibility: hidden;
  ${props => props.visible && `visibility: visible;`}
`;

export default function SortIndicator({ sortDirection, className, visible }) {
  return (
    <StyledSvg visible={visible} className={className} width={18} height={18} viewBox="0 0 24 24">
      {sortDirection === SortDirection.ASC ? (
        <path d="M7 14l5-5 5 5z" />
      ) : (
        <path d="M7 10l5 5 5-5z" />
      )}
      <path d="M0 0h24v24H0z" fill="none" />
    </StyledSvg>
  );
}

SortIndicator.propTypes = {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),
};
